/** These responses depend on live permissions/branch scope and may contain
 * payment evidence. A URL-only persistent cache cannot safely store them. */
export function isSupplierFinancialEndpoint(endpoint: string): boolean {
  const path = endpoint.split("?")[0].replace(/^\/api(?=\/)/, "").replace(/\/+$/, "");
  return /^\/supplier-payments(?:\/|$)/.test(path)
    || /^\/supplier-receipts(?:\/|$)/.test(path)
    || /^\/suppliers\/payables(?:\/|$)/.test(path)
    || /^\/suppliers\/[^/]+\/(?:payments|payables|balance|statement|terms|item-prices)(?:\/|$)/.test(path);
}

/** Remove entries written by older app versions without deleting queued work
 * or unrelated offline documents. Invoked before the DB is exposed to callers. */
export async function purgeSupplierFinancialCache(db: any): Promise<void> {
  const transaction = db.transaction("cached_docs", "readwrite");
  let cursor = await transaction.store.openCursor();
  while (cursor) {
    if (isSupplierFinancialEndpoint(String(cursor.key))) await cursor.delete();
    cursor = await cursor.continue();
  }
  await transaction.done;
}